import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// This utility function is used to get the CSS variables for the Kallisto theme.
// It flattens the tokens and converts them to CSS variables.
// This is used to inject the CSS variables into the global styles.

function flattenTokensForCss(obj, topLevelKey) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var currentPath = [topLevelKey].concat(_toConsumableArray(path), [key]);
    var varPath = currentPath.join('-');
    if (value && _typeof(value) === 'object') {
      return _objectSpread(_objectSpread({}, acc), flattenTokensForCss(value, topLevelKey, [].concat(_toConsumableArray(path), [key])));
    }
    var actualValue = value.toString();
    if (!actualValue.startsWith('var(--')) {
      acc[varPath] = actualValue;
    }
    return acc;
  }, {});
}
export function getKallistoCssVariables(theme) {
  var flattenedVars = _objectSpread(_objectSpread(_objectSpread({}, flattenTokensForCss(theme.color, 'color')), flattenTokensForCss(theme.font, 'font')), flattenTokensForCss(theme.radius, 'radius'));
  return Object.entries(flattenedVars).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return "--lmn-ds-".concat(key, ": ").concat(value, ";");
  }).join('\n');
}